import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FortuneCookie = () => {
  const [fortune, setFortune] = useState(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('hibff_auth_token') || sessionStorage.getItem('hibff_auth_token');
    fetch(`${API_URL}/api/engagement/fortune`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(data => {
        setFortune(data);
        if (data.seen) setRevealed(true);
      }).catch(() => {});
  }, []);

  const handleReveal = async () => {
    setRevealed(true);
    const token = localStorage.getItem('hibff_auth_token') || sessionStorage.getItem('hibff_auth_token');
    fetch(`${API_URL}/api/engagement/fortune/seen`, {
      method: 'POST', headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {});
  };

  if (!fortune) return null;

  return (
    <div
      className="relative bg-gradient-to-br from-purple-50 to-indigo-50 rounded-xl p-5 border border-purple-200 cursor-pointer overflow-hidden"
      onClick={!revealed ? handleReveal : undefined}
      data-testid="fortune-cookie"
    >
      <div className="flex items-center gap-2 mb-3">
        <span className="text-lg">&#10024;</span>
        <p className="text-sm font-bold text-gray-900">Today&apos;s Insight from AvA</p>
      </div>
      {revealed ? (
        <p className="text-sm text-gray-700 leading-relaxed italic" style={{ fontFamily: 'Georgia, serif' }}>
          &quot;{fortune.message}&quot;
        </p>
      ) : (
        <div className="flex items-center gap-2">
          <div className="h-10 flex items-center justify-center bg-purple-100 rounded-lg px-4">
            <p className="text-xs text-purple-600 font-medium">Tap to reveal today&apos;s insight</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default FortuneCookie;
